export const translate = (string) => {
  const tStrings = {
    "Invalid username/password.": "Ungültiger Benutzernamen/Passwort.",
    "This field must be unique.": "Dieser Benutzername wird bereits genutzt.",
    "Ensure this field has at least 8 characters.":
      "Das Passwort muss mindestens 8 Zeichen beinhalten.",
  };
  if (string in tStrings) return tStrings[string];
  else return string;
};
